// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1rsop0c0 {
  flex-direction: column;
  gap: var(--_18w76bwg);
  padding: var(--_18w76bwi);
  background-color: var(--_18w76bw23);
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,mCAAmC;AACrC","sourcesContent":["._1rsop0c0 {\n  flex-direction: column;\n  gap: var(--_18w76bwg);\n  padding: var(--_18w76bwi);\n  background-color: var(--_18w76bw23);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
